/* eslint-disable @typescript-eslint/no-unused-vars */
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IMachineContext } from 'projects/common/src/app/interfaces/machine-context';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { Subject } from 'rxjs';
import { MachineContextService } from 'src/app/modules/core/services/parameter/machine-context/machine-context.service';
import { DashboardFacade } from 'src/app/modules/core/store/dashboard/dashboard.facade';
import { IMachineStatus } from 'src/app/modules/widget/interfaces/machine-status';
import { StatusModalShellComponent } from '../status-modal-shell/status-modal-shell.component';

@Component({
  selector: 'app-machine-status',
  templateUrl: './machine-status.component.html',
  styleUrls: ['./machine-status.component.scss'],
})
export class MachineStatusComponent implements OnInit, OnDestroy {
  @Input()
  public machines: IMachineStatus[];

  public hasViewChange: boolean;
  public class: string;
  public currentMachine: string;
  public machineValue: { quantity: string; unit?: string; traduction?: { singular?: string; plural?: string } | string };
  public reloadWidget: Subject<any>;
  public tooltipDescription: string;
  public animate = false;

  @Input()
  public isHCM: boolean;

  @Input()
  public isScoop: boolean;

  @Input()
  public traduction: string;

  constructor(
    private cdRef: ChangeDetectorRef,
    public machineContext: MachineContextService,
    private langService: LanguageService,
    private modalService: NgbModal,
    public dashboardFacade: DashboardFacade,
  ) {
    this.reloadWidget = new Subject<any>();
    this.tooltipDescription = this.langService.message('outside-park');
  }

  /**
   * Init app
   */
  public ngOnInit(): void {
    this.machineContext.getObservable().subscribe(
      (machine: IMachineContext) => {
        this.currentMachine = machine.name;

        this.machineValue = this.getMachineValue(machine.name);
        this.cdRef.detectChanges();
      },
      (error) => {},
    );
  }

  /**
   * Function to get the machine value to show
   *
   * @param machineName: machine name
   */
  private getMachineValue(machineName: string): {
    quantity: string;
    unit?: string;
    traduction?: { singular?: string; plural?: string } | string;
  } {
    switch (machineName) {
      case 'scoop':
        return {
          quantity: 'loop',
          unit: 'loops',
        };
      case 'jumbo':
        return {
          quantity: 'drilling',
          unit: 'drillings_mts',
          traduction: { singular: 'drilling', plural: 'drillings' },
        };
      case 'manitou':
        return {
          quantity: 'operative_hour',
          unit: 'operative_hour',
        };
      case 'lhd':
        return {
          quantity: 'shelve',
          unit: 'tons',
          traduction: { singular: 'shelve', plural: 'shelves' },
        };
      case 'train':
        return {
          quantity: 'loop',
          unit: 'tons',
        };
      case 'roboshot':
        return {
          quantity: 'operative_hour',
          unit: 'operative_hour',
        };
      case 'acunador':
        return {
          quantity: 'operative_hour',
          unit: 'operative_hour',
        };
      case 'truck':
        return {
          quantity: 'transfers',
          traduction: { singular: 'transfers', plural: 'loops' },
          unit: 'tons',
        };
      default:
        return {
          quantity: 'loop',
          unit: 'tons',
          traduction: { singular: 'no-translate', plural: 'no-translate' },
        };
    }
  }

  public changeStatusModal(value: IMachineStatus): void {
    const componentRef = this.modalService.open(StatusModalShellComponent, {
      centered: true,
      windowClass: 'status-modal',
    });
    componentRef.componentInstance.machineStatus = value;
  }

  handleImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = '../../../../../../../assets/img/dashboard-lhd/onemine-default-default.svg';
  }

  public getTooltipText(machine: any): string {
    return machine.isOutOfPark ? `${this.tooltipDescription} \n  ${machine.lastZoneName}` : '';
  }

  /**
   * Destroy component
   */
  public ngOnDestroy(): void {
    this.reloadWidget.complete();
  }
}
